<template>
<div>

        <form @submit ="onSubmit">
             <div class="suggestionPop">
                 <input id="suggestions" class="inputSuggestions" type="text" placeholder="Enter search term ..." v-model="search"
                        autocomplete="off" aria-autocomplete="none"
                        @input="onChange" @keyup.down="onArrowDown" @keyup.up="onArrowUp" @keyup.enter="onEnter">

                <button @click="submitSearch" type="button" class="btnSuggestions">Go</button>

        <div class="suggestedList " v-show="popShow">
            <div v-if="errored" class="popHeader">
                <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
            </div>
            <div v-else>
                <div v-if="loading" class="popHeader">Loading...</div>
                <div v-else>


                <div class="popHeader">
                    <span v-if="returnResult">Recommended Links</span>
                    <span v-else>No Recommendations</span>
                </div>

                <div v-if="returnResult">

                    <ul class="suggestionList-group">
                        <a v-for="(data,i) in filteredSuggestion" :key="data.id" :href="URL(data)"><li class="suggestionList-item"
                            @mouseover="hoveritem(i)"
                            @click="onClickItem(data)"
                            :class="{ 'is-active': i === arrowCounter}"
                        >

                                <span class= "dataTitle">{{data.suggestion}}</span><br>
                                <span class= "dataSubtitle">{{data.info}}</span>
                        </li></a>
                        <li v-if="viewSearchResults.active" @click="sendSearch" class="is-active viewSearchStyle suggestionList-item">{{viewSearchResults.text}}<img class="rightArrow" src= "../assets/rightArrow.gif" border ="0"/></li>
                        <li v-else @mouseover="onHoverView" @click="sendSearch" class="viewSearchStyle suggestionList-item">{{viewSearchResults.text}}<img class="rightArrow" src= "../assets/rightArrow.gif" border ="0"/>  </li>
                    </ul>

                </div>

                <div v-else>
                    <ul class="suggestionList-group">
                        <li class="suggestionList-item is-active viewSearchStyle" @click="sendSearch">{{viewSearchResults.text}}<img class="rightArrow" src= "../assets/rightArrow.gif" border ="0"/></li>
                    </ul>
                </div>
                </div>
            </div>
        </div>
    </div>


        </form>

</div>

</template>

<script>

    import axios from 'axios'
    //console.log(suggestionData);

export default {
    data () {
    return {
        suggestionData: [],
        //suggestionData: suggestionData,
        loading: true, // change to true
        errored: false,
        popShow: false,
        returnResult: false,
        search: '',
        arrowCounter: -1,
        viewSearchResults : {
            text: "View all search results",
            active: false

        }

    }
  },
    computed: {
        //Filtered Suggestion returns the array that contains the search results and sorts the array by priority
        filteredSuggestion(){
            let filteredArray = this.suggestionData.filter(data => {

                let userSearch = this.search.toLowerCase();

                let keywordMatch = this.checkKeywords(data.keywords, userSearch);

                //Check if search input matches a keyword, index 0 is teh closest match
                if(data.keywords.indexOf(keywordMatch[0])>=0){
                    return data.suggestion;
                }
                //check if search input matches suggestion field
                if(data.suggestion.toLocaleLowerCase().startsWith(userSearch)){
                        return data.suggestion;
                    }
                //check if search input matches info field
                if(data.info.toLocaleLowerCase().startsWith(userSearch)){
                    return data.suggestion;
                }
            })

            //if the size of the filtered array is > 0 then that means there are results to show,
            if(filteredArray.length > 0){
                this.returnResult = true;
            }
            //otherwise no results to show
            else {
                this.returnResult = false
            }

            //sort the filtered array by priority
             let sortedArray = filteredArray.sort( function (a,b) {
                   return a.priority - b.priority;

                 });
            return sortedArray.slice(0,10); //the final sorted/filtered array up to 10 matches to display


        },
        searchURI (){
             //creating URL for the GET request
            let url = 'https://www.wcsu.edu/search.asp';
            let uri = '?q='+ this.search;

            return url+uri;
         }

    },
    methods: {

        // returns an array that contains all of the keywords that match the search input
        checkKeywords( data, searchInput ){
           return data.filter(key=>{
               return key.toLowerCase().startsWith(searchInput)
           })
        },
        //Input Events
        onChange () {
            if(this.search === ''){
                this.popShow = false;
                this.arrowCounter = -1;
            }
            else{
                this.popShow = true;
                this.filteredSuggestion;
                this.arrowCounter  = -1;
                this.viewSearchResults.active = false;
                console.log("CHANGE");
            }
        },
        //Key Events
        onArrowDown(evt){
            if (this.arrowCounter < this.filteredSuggestion.length && this.search !== '' ) {
               this.arrowCounter = this.arrowCounter + 1;
               console.log("Down-- ArrowCounter: " + this.arrowCounter)
            }
            if(this.arrowCounter === this.filteredSuggestion.length){
                this.viewSearchResults.active = true
                this.arrowCounter = this.filteredSuggestion.length;
            }
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1;
                console.log("UP-- ArrowCounter: " + this.arrowCounter)
            }
            if(this.arrowCounter < this.filteredSuggestion.length){
                this.viewSearchResults.active = false;
            }
        },
        onEnter() {
            //search returned a result
            if(this.returnResult){
                //if results are found
                console.log("Results");
                if (this.arrowCounter < 0){
                    this.submitSearch();
                }
                //
                else {
                    if(this.viewSearchResults.active){
                        this.submitSearch();
                    }
                    else {
                        window.location.href = this.URL(this.filteredSuggestion[this.arrowCounter]);
                        this.search = this.filteredSuggestion[this.arrowCounter].suggestion;
                        this.arrowCounter = -1;
                    }
                }

            }
            //no result is returned.
            else {
                console.log("No results");
                this.submitSearch();
            }
        },
        //Click Events
        onClickItem (data) {
            this.search = data.suggestion
        },
        sendSearch(){
          this.submitSearch()  ;
        },
        handleClickOutside(evt) {
            if (!this.$el.contains(evt.target)) {
                this.popShow = false;
                this.arrowCounter = -1;
                console.log("OUT")
            }
        },
        //Hover Events
            //in the filtered array list
        hoveritem (index) {
            if(this.viewSearchResults.active === false){
                this.arrowCounter = index;
            }
            else{
                if (index < this.filteredSuggestion.length){
                    this.viewSearchResults.active = false;
                }

            }
        },
            //hover over the View all search results
        onHoverView(){
            this.viewSearchResults.active=true;
            this.arrowCounter = this.filteredSuggestion.length;
        },
        //Other events
        submitSearch()
        {
          window.location.href = this.searchURI;
        },
        onSubmit (evt) {
            evt.preventDefault();
            console.log('SUBMIT');
        },
        URL (data) {
            let output = data.url;
            return output;
        }

    },
    created() {
        let suggestionDataJson = '/api/westsuggest/data.json';

    axios
      .get(suggestionDataJson)
      .then(response => {

        this.suggestionData = response.data.suggestions;
        console.log(this.suggestionData)



                        })
        .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.loading = false)
        document.addEventListener("click", this.handleClickOutside);

    },
    destroyed() {
        document.removeEventListener("click", this.handleClickOutside);
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .inputSuggestions{
        padding:.375rem .75rem;

        line-height: 1.8;
        color: #495057;
        background-color: white;
        border: 1px solid #ced4da;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        margin-right: 5px;
        width: 260px;


    }
    .btnSuggestions:hover {
        cursor: pointer;
    }
    .btnSuggestions{
        color: white;
        background-color: #002856;
        display:inline-block;
        font-weight: 400;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        border: 1px solid #002856;
        border-radius: 0.25em 0.25em 0.25em 0.25em;
        padding: .385rem .85rem;
        font-size:1.6rem;
        line-height: 1.6;

    }
    .suggestionPop .suggestedList{
        width:276px !important;
        position: absolute;
        line-height: 1.5;
        margin: 5px;
        border: 1px solid #dddddd;
        border-radius: .3rem;
        left: -12px;
        top: 48px;
        z-index: 1028;

    }
    .suggestedList:after, .suggestedList:before{
        bottom: 100%;
        left: 50%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }
    .suggestedList:after {
        border-color: rgba(255, 255, 255, 0);
        border-bottom-color: #fff;
        border-width: 12px;
        margin-left: -12px;
    }
    .suggestedList:before {
        border-color: rgba(221, 221, 221, 0);
        border-bottom-color: #dddddd;
        border-width: 15px;
        margin-left: -15px;
    }
    .popHeader{
        background-color: #f7f7f7;
        padding: .5rem .75rem;
        color: inherit;
    }
    .suggestionList-group{
        list-style-type: none; /* Remove bullets */
        padding: 0; /* Remove padding */
        margin: 0; /* Remove margins */

    }
    .suggestionList-group a{
        text-decoration: none;
        color: black;
    }
    .suggestionList-item{
        border: 1px solid #ddd; /* Add a thin border to each list item */
        margin-top: -1px; /* Prevent double borders */
        background-color: #fff;
        padding: 12px; /* Add some padding */

    }
    .is-active{
        background-color: #003da6;
        border-color: #93a5b9;
        color: white;
        cursor: pointer;
    }
    .viewSearchStyle{
        font-weight: bolder;

    }
    .rightArrow{
        padding-left: 9px;
        margin-bottom: -4px;
    }

    .dataTitle{
        font-weight: bold;
    }
    .dataSubtitle{

    }
    .suggestionPop{
        position:relative;
    }


</style>



// WEBPACK FOOTER //
// src/components/searchBar.vue